import React from 'react';

import { staticRoutes } from 'Deer/constants/routes';
import { PageNotFound404 } from 'Deer/pages/PageNotFound404';
import AdminOrManagerRoute from 'components/AdminOrManagerRoute';
import { Route, Switch } from 'react-router-dom';
import { CustomRole } from 'screens/admin/CustomRole';
import Employees from 'screens/admin/Employees';
import FunctionAndGrade from 'screens/admin/FunctionAndGrade';
import { ModuleSettingsV1 } from 'screens/admin/ModuleSettingsV1';
import NotificationsDeer from 'screens/admin/NotificationsDeer';
import OrgSettings from 'screens/admin/OrgSettings';
import { checkSettingsPageRevampEnabled } from 'utils/helpers/featureFlags';

import { CUSTOM_ADMIN, PLATFORM_ADMIN } from 'constants/ProjectConstants';
import { isNetchexLogin } from 'constants/netChexConstants';

import CustomRoleIntent from '../EmployeeRoster/CustomRoleIntent';
import EmployeeRosterIntent from '../EmployeeRoster/EmployeeRosterIntent';
import { NetchexMiscellaneousSettings } from '../NetchexMiscellaneousSettings';
import { NotificationSettings } from '../Notification/NotificationSettings';
import { OrganizationSettings } from './OrganizationSettings';

const PlatformSettings = () => {
  const isSettingsPageRevampEnabled = checkSettingsPageRevampEnabled();

  return (
    <Switch>
      <AdminOrManagerRoute
        exact
        path={staticRoutes.company.settings.platform.access}
        component={checkSettingsPageRevampEnabled() ? CustomRoleIntent : CustomRole}
        redirectionPath={staticRoutes.home}
        roles={[PLATFORM_ADMIN]}
      />
      <AdminOrManagerRoute
        exact
        path={staticRoutes.company.settings.platform.employees}
        component={checkSettingsPageRevampEnabled() ? EmployeeRosterIntent : Employees}
        redirectionPath={staticRoutes.home}
        roles={[PLATFORM_ADMIN]}
      />
      <AdminOrManagerRoute
        exact
        path={staticRoutes.company.settings.platform.notifications}
        component={
          isSettingsPageRevampEnabled
            ? isNetchexLogin
              ? NetchexMiscellaneousSettings
              : NotificationSettings
            : NotificationsDeer
        }
        redirectionPath={staticRoutes.home}
        roles={isNetchexLogin ? [PLATFORM_ADMIN, CUSTOM_ADMIN] : [PLATFORM_ADMIN]}
      />
      <AdminOrManagerRoute
        exact
        path={staticRoutes.company.settings.platform['function-grade']}
        component={FunctionAndGrade}
        redirectionPath={staticRoutes.home}
        roles={[PLATFORM_ADMIN]}
      />
      <AdminOrManagerRoute
        exact
        path={staticRoutes.company.settings.platform.modules}
        component={ModuleSettingsV1}
        redirectionPath={staticRoutes.home}
        roles={[PLATFORM_ADMIN]}
      />
      <AdminOrManagerRoute
        exact
        path={staticRoutes.company.settings.platform.organization}
        component={isSettingsPageRevampEnabled ? OrganizationSettings : OrgSettings}
        redirectionPath={staticRoutes.home}
        roles={[PLATFORM_ADMIN]}
      />
      <Route path="*" component={PageNotFound404} />
    </Switch>
  );
};

export default PlatformSettings;
